import { initProductSelectorWizard } from "./product-selector-page/wizard";
import { initProductSelectorFeedback } from "./product-selector-page/feedback";

const cfg =
  typeof ignitedProductSelector !== "undefined" ? ignitedProductSelector : null;

function boot() {
  if (cfg) {
    initProductSelectorWizard(cfg);
    initProductSelectorFeedback(cfg);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
